const THIRTIES_MODE_KEY = "30s-are-the-new-20s";
const TELUGU_THANKSGIVING_MODE_KEY = "indian-thanksgiving";

const thirtiesAreTheNewTwentiesEntries = [
  ["Quarter life crisis", ["twenties", "lost", "purpose", "direction", "confusion"]],
  ["DINK", ["carefree", "income", "child free", "kids", "parents"]],
  ["Meal prep", ["cook", "food", "plan", "week", "containers"]],
  ["Work life balance", ["juggle", "time", "stress", "job", "hours"]],
  ["Remote year", ["travel", "laptop", "nomad", "abroad", "work"]],
  ["Dog parent", ["puppy", "walk", "pet", "fur", "owner"]],
  ["Group chat", ["text", "thread", "messages", "friends", "phone"]],
  ["Plant dad", ["green", "trees", "watering", "houseplant", "succulents"]],
  ["Wine club", ["tasting", "bottles", "subscription", "grapes", "vineyard"]],
  ["Digital detox", ["offline", "phone", "social", "screen", "break"]],
  ["Couch to 5K", ["running", "program", "exercise", "training", "jog"]],
  ["Wellness retreat", ["spa", "yoga", "meditation", "resort", "relax"]],
  ["Home office", ["desk", "chair", "workspace", "remote", "setup"]],
  ["Microdosing", ["psychedelic", "small", "dose", "mushroom", "experiment"]],
  ["Z Biotics", ["pre alcohol", "probiotics", "drink", "sober", "hangover"]],
  ["Starter home", ["first", "house", "mortgage", "buy", "property"]],
  ["Staycation", ["home", "vacation", "airbnb", "hotel", "break"]],
  ["Kitchen renovation", ["remodel", "cabinets", "counter", "tiles", "update"]],
  ["Book club", ["read", "novel", "discussion", "meeting", "chapter"]],
  ["Farmers market", ["produce", "local", "organic", "stall", "fresh"]],
  ["Fantasy football", ["draft", "league", "players", "team", "points"]],
  ["Brewery tour", ["beer", "tasting", "craft", "pints", "taproom"]],
  ["Thrifting", ["secondhand", "vintage", "store", "cheap", "finds"]],
  ["Sourdough starter", ["bread", "yeast", "ferment", "bake", "loaf"]],
  ["Grocery delivery", ["online", "order", "doordash", "shopping", "instacart"]],
  ["Pet insurance", ["vet", "coverage", "policy", "costs", "claims"]],
  ["Credit card points", ["rewards", "miles", "cashback", "spend", "bonus"]],
  ["Health tracker", ["fitness", "watch", "steps", "sleep", "heart"]],
  ["Electric vehicle", ["Elon Musk", "battery", "car", "Tesla", "Solar"]],
  ["Career pivot", ["switch", "industry", "change", "transition", "job"]],
  ["Adulting", ["responsibility", "bills", "laundry", "grown up", "chores"]],
  ["Therapy", ["mental", "health", "talk", "counselor", "emotions"]],
  ["Side hustle", ["job", "extra", "freelance", "money", "gig"]],
  ["Glow up", ["makeover", "transformation", "beauty", "upgrade", "before"]],
  ["Millennial", ["generation", "born", "1980s", "1990s", "age"]],
  ["Burnout", ["tired", "stress", "exhausted", "work", "overwhelmed"]],
  ["Dating apps", ["Tinder", "swipe", "online", "match", "profile"]],
  ["Biohacking", ["optimize", "supplements", "cold plunge", "Bryan Johnson", "track"]],
  ["FIRE", ["retire", "early", "independence", "investing", "smoke"]],
  ["Podcast", ["listen", "audio", "Spotify", "host", "show"]],
  ["Ghosting", ["disappear", "text", "message", "ignore", "dating"]],
  ["Fertility", ["eggs", "pregnancy", "clock", "freeze", "IVF"]],
  ["Board game night", ["friends", "strategy", "dice", "cards", "catan"]],
  ["Destination wedding", ["marriage", "ceremony", "couple", "celebration", "travel"]],
  ["Japan", ["travel", "asia", "shogun", "cherry blossoms", "tokyo"]],
  ["Quiet Quitting", ["minimum", "effort", "work", "disengagement", "boundaries"]],
  ["Avocado Toast", ["brunch", "trendy", "expensive", "food", "millennial"]],
  ["Doomscrolling", ["news", "anxiety", "social media", "negative", "endless"]],
  ["Situationship", ["undefined", "dating", "relationship", "casual", "confusing"]],
  ["Soft Launch", ["reveal", "subtle", "relationship", "social media", "hint"]],
  ["Delulu", ["delusional", "optimistic", "dreaming", "manifesting", "unrealistic"]],
  ["Gaslighting", ["manipulation", "doubt", "sanity", "control", "abusive"]],
  ["Gatekeeping", ["exclusive", "information", "control", "community", "hoard"]],
  ["Main Character", ["confidence", "protagonist", "life", "vibe", "hero"]],
  ["Rizz", ["charisma", "flirt", "charm", "game", "attraction"]],
  ["No Cap", ["truth", "seriously", "for real", "honest", "sincere"]],
  ["Green flag", ["positive", "healthy", "trait", "relationship", "good"]],
  ["Attachment style", ["anxious", "avoidant", "secure", "relationship", "childhood"]],
  ["Love Languages", ["touch", "affirmation", "gifts", "quality", "service"]],
  ["Eras Tour", ["Taylor", "concert", "Swift", "album", "tickets"]],
  ["Joe Rogan", ["podcast", "Spotify", "UFC", "controversial", "bald"]],
  ["White Lotus", ["resort", "HBO", "guests", "murder", "satire"]],
  ["BeReal", ["app", "photo", "daily", "authentic", "notification"]],
  ["Linkin Park", ["rock", "numb", "Chester", "band", "Hybrid Theory"]],
  ["Pink Floyd", ["wall", "classic", "rock", "dark", "moon"]],
  ["Vibe Coding", ["cursor", "windsurf", "AI", "bugs", "typing"]],
  ["Bitcoin", ["crypto", "blockchain", "mining", "wallet", "Satoshi"]],
  ["Metaverse", ["VR", "avatar", "virtual", "Zuck", "web3"]],
  ["Manifesting", ["affirmation", "energy", "universe", "attract", "visualize"]],
  ["FOMO", ["miss", "experience", "event", "regret", "invitation"]],
  ["Cancel Culture", ["drama", "callout", "unfollow", "controversy", "trending"]],
  ["GrWM", ["routine", "makeup", "fashion", "aesthetic", "vlog"]],
  ["Salty", ["bitter", "jealous", "petty", "upset", "shade"]],
  ["Wordle", ["guess", "letters", "daily", "new york times", "puzzle"]],
  ["Fake News", ["misinformation", "viral", "fact check", "headline", "clickbait"]],
  ["Binge watch", ["series", "episodes", "Netflix", "marathon", "snack"]],
  ["BlackBerry", ["keyboard", "email", "business", "phone", "fruit"]],
  ["Flip Phone", ["motorola", "razr", "hinge", "antenna", "retro"]],
  ["iTunes", ["apple", "music", "store", "download", "sync"]],
  ["Airbnb", ["rent", "vacation", "host", "booking", "home share"]],
  ["ChatGPT", ["AI", "OpenAI", "language model", "assistant", "prompt"]],
  ["Patagonia Jacket", ["down", "VC", "waterproof", "warm", "tech bro"]],
  ["Bernie Sanders", ["socialist", "progressive", "democrat", "politics", "voter"]],
  ["The Office", ["Dunder", "Mifflin", "Michael", "Scranton", "steve carell"]],
  ["Pilates", ["stretch", "yoga", "core", "balance", "toning"]],
  ["Bachelorette", ["party", "wedding", "vegas", "bride", "girls"]],
  ["Rocket League", ["car", "soccer", "game", "cars", "football"]],
  ["Theragun", ["massage", "fitness", "deep", "pain", "relief"]],
  ["Effective Altruism", ["charity", "donate", "impact", "effective", "donor"]],
  ["Caffeine", ["coffee", "energy", "drink", "tea", "matcha"]],
];

const indianThanksgivingEntries = [
  ["Costco", ["membership", "samples", "bulk", "cart", "Kirkland"]],
  ["Biryani", ["rice", "spicy", "Hyderabad", "chicken", "layers"]],
  ["Rajamouli", ["director", "RRR", "Baahubali", "blockbuster", "epic"]],
  ["Tesla", ["car", "Elon", "electric", "autopilot", "charging"]],
  ["Mashed Potatoes", ["gravy", "thanksgiving", "butter", "side", "fluffy"]],
  ["KGF", ["rocky", "gold", "Kannada", "movie", "mass"]],
  ["H1B Lottery", ["visa", "job", "USCIS", "immigration", "stress"]],
  ["Green Card", ["immigration", "permanent", "visa", "waiting", "status"]],
  ["Panipuri", ["spicy", "street", "water", "crisp", "chutney"]],
  ["Rajinikanth", ["superstar", "style", "thalaiva", "punch", "mass"]],
  ["Indian Buffet", ["naan", "curry", "tray", "rice", "restaurant"]],
  ["Karthika Masam", ["lamps", "temple", "pooja", "auspicious", "season"]],
  ["Instant Pot", ["electric", "modern", "cooking", "rice", "steam"]],
  ["Filter Coffee", ["caffeine", "froth", "strong", "South Indian", "morning"]],
  ["Air India Flight", ["overhead", "delayed", "food", "announcement", "smell"]],
  ["Telugu Serial", ["drama", "crying", "villain", "tv show", "episode"]],
  ["Tupperware Collection", ["leftovers", "stack", "lids", "kitchen", "missing"]],
  ["Jet Lag", ["sleep", "India", "time", "coffee", "adjust"]],
  ["Spelling Bee", ["kids", "dictionary", "champion", "stage", "word"]],
  ["Maggie Noodles", ["instant", "two minutes", "yellow", "slurp", "packet"]],
  ["Lays Magic Masala", ["blue packet", "chips", "spicy", "snack", "favorite"]],
  ["Peppa Pig", ["British", "muddy puddles", "George", "snort", "cartoon"]],
  ["Chota Bheem", ["Dholakpur", "laddu", "cartoon", "strong", "kids"]],
  ["UNO", ["reverse", "skip", "draw", "cards", "colors"]],
  ["Cricket Match", ["bat", "ball", "run", "India", "wicket"]],
  ["WhatsApp Forward", ["group", "message", "aunty", "fake news", "share"]],
  ["Chandrababu Naidu", ["chief minister", "Andhra Pradesh", "politics", "TDP", "Hitech city"]],
  ["Rupee Conversion", ["dollar", "exchange", "rate", "India", "math"]],
  ["Gold Rate", ["price", "India", "ornaments", "wedding", "investment"]],
  ["Delulu", ["delusional", "optimistic", "dreaming", "manifesting", "unrealistic"]],
  ["ChatGPT", ["AI", "OpenAI", "language model", "assistant", "prompt"]],
  ["Doomscrolling", ["news", "anxiety", "social media", "negative", "endless"]],
  ["Main Character", ["confidence", "protagonist", "life", "vibe", "hero"]],
  ["Eras Tour", ["Taylor", "concert", "Swift", "album", "tickets"]],
  ["TikTok", ["video", "dance", "trend", "scroll", "app"]],
  ["AirPods", ["Apple", "music", "wireless", "Bluetooth", "ears"]],
  ["Side Hustle", ["money", "job", "extra", "freelance", "income"]],
  ["Masala Dosa", ["crispy", "south indian", "breakfast", "chutney", "sambar"]],
  ["Jugaad", ["creative", "problem solving", "hack", "resourceful", "innovative"]],
  ["ABCD", ["American Born", "Confused Desi", "second generation", "Indian American", "Mixed Culture"]],
  ["Hinglish", ["Hindi English", "mixed language", "communication", "dialect", "hybrid"]],
  ["Avakaya", ["oil", "spicy", "pickle", "grandma", "mango"]],
  ["Samosa", ["fried", "tea", "potatoes", "chutney", "snack"]],
  ["IVY League", ["college", "Harvard", "Yale", "elite", "school"]],
  ["Texan", ["football", "cowboy", "houston", "ranch", "hat"]],
  ["Bala Krishna", ["actor", "telugu", "old", "jai", "nandamuri"]],
  ["thanksgiving", ["november", "turkey", "family", "dinner", "cranberry sauce"]],
  ["6,7", ["six", "seven", "numbers", "genz lingo", "basketball players height"]],
  ["coke zero", ["diet", "soda", "sugar free", "zero calories", "fizzy"]],
  ["baccha party", ["kids", "group", "friends", "play", "fun"]],
];

const tabooModeEntries = {
  [TELUGU_THANKSGIVING_MODE_KEY]: indianThanksgivingEntries,
  [THIRTIES_MODE_KEY]: thirtiesAreTheNewTwentiesEntries,
};

export const TABOO_MODES = [
  {
    key: TELUGU_THANKSGIVING_MODE_KEY,
    label: "Telugu Thanksgiving",
  },
  {
    key: THIRTIES_MODE_KEY,
    label: "30s Are The New 20s",
  },
];

export const DEFAULT_TABOO_MODE = THIRTIES_MODE_KEY;

function shuffleArray(array) {
  const shuffled = [...array];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[randomIndex]] = [
      shuffled[randomIndex],
      shuffled[index],
    ];
  }

  return shuffled;
}

export function getTabooModeLabel(modeKey) {
  const matchedMode = TABOO_MODES.find((mode) => mode.key === modeKey);
  return matchedMode?.label || TABOO_MODES[0].label;
}

export function createTabooDeck(modeKey = DEFAULT_TABOO_MODE) {
  const entries = tabooModeEntries[modeKey] || tabooModeEntries[DEFAULT_TABOO_MODE];

  return shuffleArray(
    entries.map(([word, taboo], index) => ({
      id: `${modeKey}-${index}`,
      word,
      taboo: [...taboo],
    })),
  );
}

export function getTabooCardCount(modeKey = DEFAULT_TABOO_MODE) {
  const entries = tabooModeEntries[modeKey] || tabooModeEntries[DEFAULT_TABOO_MODE];
  return entries.length;
}
